import React, { Component } from 'react'
import _ from 'lodash'
import { Grid, Row, Col, FormGroup, ControlLabel } from 'react-bootstrap'
import PhoneNumber from '../../felles/utils/PhoneNumber';
import Validation from 'react-validation'
import uuid from 'uuid/v4'
import NKIcon from '@norkart/ikoner'
import NkaButton from 'nka-button'
import Repository from '../../felles/repository'
import { resolve } from '../../dependencies'
import Loading from '../../felles/loading'
import ModalImageCapture from '../../felles/Bilder/modal-image-capture'
import { AppInsights } from 'applicationinsights-js'

import '../../felles/valideringsRegler'
import './vannmaaler.css'
import 'nka-button/dist/style.css'

export default class IkkeSkifetMaaler extends Component {
    constructor(props) {
        super(props)

        this.state = {
            bildeAvMaaler: [],
            taBilde: false,
            infotekst: '',
            BytterMaaler: false
        }

        this._ferdig = this._ferdig.bind(this)
        this._avbryt = this._avbryt.bind(this)
        this._handleTekstEndret = this._handleTekstEndret.bind(this)
        this._taBildeAvGammelMaaler = this._taBildeAvGammelMaaler.bind(this)
        this._bildeTatt = this._bildeTatt.bind(this)
        this._slettBilde = this._slettBilde.bind(this)
        this._lagBildeElmement = this._lagBildeElmement.bind(this)
        this._gaaTilArbeidsliste = this._gaaTilArbeidsliste.bind(this)
    }

    _taBildeAvGammelMaaler() {
        this.setState({
            taBilde: true
        })
    }

    _bildeTatt(image, tekst) {
        var bilder = this.state.bildeAvMaaler

        let bildeObj = {
            Id: bilder.length,
            Bilde: image,
            Kommentar: tekst ? tekst : 'Ikke skiftet måler'
        }

        bilder.push(bildeObj)

        this.setState({
            bildeAvMaaler: bilder,
            taBilde: false
        })
    }

    _slettBilde(id) {
        var bilder = this.state.bildeAvMaaler

        var oppdatert = _.filter(bilder, function(bilde) {
            return bilde.Id !== id
        })

        this.setState({
            bildeAvMaaler: oppdatert
        })
    }

    _lagBildeElmement(bilde) {
        if (bilde.Bilde) {
            return (
                <Col xs={12} key={bilde.Id}>
                    <div className="bilde">
                        <img src={bilde.Bilde} width="150" height="100" alt={bilde.Kommentar} />
                        <button
                            className="delete-button"
                            onClick={() => this._slettBilde(bilde.Id)}
                        >
                            <NKIcon icon="soppelbotte" size="1" color="nk-black" />
                        </button>
                    </div>
                </Col>
            )
        }
    }

    _ferdig = event => {
        event.preventDefault()

        this.setState({
            BytterMaaler: true
        })

        var bilde = _.head(this.state.bildeAvMaaler)

        let bildeSomSkalSendes = bilde && bilde.Bilde ? _.split(bilde.Bilde, ',', 2)[1] : ''

        let byttedataSomSkalSendes = {
            BytteId: uuid(),
            ArbeidslisteId: this.props.match.params.ListeId,
            IkkeSkiftetMaaler: true,
            IkkeSkiftetMaalerTekst: this.state.infotekst,
            IkkeskiftetMaalerBildeData: bildeSomSkalSendes
        }

        let gammelMaaler = {
            Maalernummer: String(this.props.location.state.maalerInfoForIkkeskifet.MaalerNummer)
        }

        let bytteData = {
            MaalepunktId: this.props.location.state.maalerInfoForIkkeskifet.MaalepunktId,
            GammelMaaler: gammelMaaler,
            GammelvannmaalerId: this.props.match.params.Id
        }

        AppInsights.trackEvent(
            'ikke skiftet måler for ' +
                byttedataSomSkalSendes.BytteId +
                ' for målepunkt ' +
                gammelMaaler.Maalernummer
        )

        byttedataSomSkalSendes.BytteData = bytteData

        resolve(Repository)
            .utforeMaalerSkifte(byttedataSomSkalSendes)
            .then(this._gaaTilArbeidsliste)
    }

    _gaaTilArbeidsliste() {
        this.props.history.push('/utskiftning/' + this.props.match.params.ListeId)
    }

    _handleTekstEndret(data) {
        this.setState({
            infotekst: data.target.value
        })
    }

    _avbryt() {
        this.props.onClose(null, '')
    }

    render() {
        AppInsights.trackPageView("Ikke skiftet måler")

        var bilder = _.map(this.state.bildeAvMaaler, this._lagBildeElmement)
        return (
            <div>
                {this.state.BytterMaaler ? (
                    <Loading tekst="Registrer data" />
                ) : (
                    <Grid>
                        <h2>
                            {this.props.location.state.maalerInfoForIkkeskifet.MaalepunktAdresse}
                        </h2>
                        <strong className="font16">
                            {this.props.location.state.maalerInfoForIkkeskifet.Eiernavn}{' '}
                        </strong>
                        <br />
                        Tlf:{' '}
                        <PhoneNumber
                            number={this.props.location.state.Mobilnummer}
                            isLinked={true}
                        />{' '}
                        /{' '}
                        <PhoneNumber
                            number={this.props.location.state.Telefonnummer}
                            isLinked={true}
                        />
                        <br />
                        <p>Avtaletype: {this.props.location.state.Avtaletype}</p>
                        <div className="plassering" style={{ marginBottom: 5 + 'px' }}>
                            <strong className="font16">Ikke skiftet måler</strong>

                            <Row>
                                <Col xs={12}>
                                    <NkaButton
                                        icon="kamera"
                                        onClick={this._taBildeAvGammelMaaler}
                                    >
                                        Ta bilde
                                    </NkaButton>
                                </Col>
                            </Row>
                            {this.state.taBilde && (
                                <ModalImageCapture
                                    visBilekommentar={false}
                                    onClose={this._bildeTatt}
                                />
                            )}

                            <Row>{this.state.bildeAvMaaler.length > 0 && bilder}</Row>

                            <Validation.components.Form
                                ref={c => (this.form = c)}
                                onSubmit={this._ferdig}
                            >
                                <Row>
                                    <Col sm={10}>
                                        <FormGroup>
                                            <ControlLabel>Info</ControlLabel>
                                            <Validation.components.Textarea
                                                errorClassName="is-invalid-input"
                                                cols="40"
                                                rows="2"
                                                validations={['required', 'mindreEnn100Tegn']}
                                                value={this.state.infotekst}
                                                placeholder="Årsak til at måler ikke er skiftet"
                                                onChange={this._handleTekstEndret}
                                                className="form-control"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={10} md={10}>
                                        <Validation.components.Button
                                            className="btn btn-primary  btn-block hoeyde48 "
                                            style={{ marginBottom: '15px' }}
                                        >
                                            Fullfør
                                        </Validation.components.Button>
                                    </Col>
                                </Row>
                            </Validation.components.Form>
                        </div>
                    </Grid>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/ikkeskiftetmaaler.jsx